module.exports = __webpack_public_path__ + "static/media/andras-vas-Bd7gNnWJBkU-unsplash.90769897.jpg";